
import CreditSettlement from "pages/credit-settlement";
import SharePercent from "pages/sharePercent";

import { lazy } from "react";
const Hub = lazy(() => import("pages/Hub"));
const OperationalScopeManagement = lazy(
  () => import("pages/map/zoneMap/OperationalScopeManagement")
);
const DetermainGeo = lazy(
  () => import("pages/determain-geographic-areas/index")
);

const Planing = lazy(() => import("pages/Planing"));
const UnPlanedConsignemnt=lazy(()=>import("pages/unplaned-consignments")) 
const CreditAllocate=lazy(()=>import("pages/credit-allocate")) 
const FishManagement=lazy(()=>import("pages/fish-management")) 
const DesorganizationMangement=lazy(()=>import("pages/desorgainzation-mangement")) 

export const childs: Array<ISideBarChild> = [
  {
    code: "1001",
    to: "/hub",
    component: <Hub />,
    label: "هاب",
    permissions: "view_hub",
  },
  {
    code: "100103",
    to: "/basic-information/map-zone",
    component: <OperationalScopeManagement />,
    label: "تعریف محدوده عملیاتی",
    permissions: "view_map_zone",
  },
  {
    code: "100104",
    to: "/basic-information/map-zone-operation",
    component: <DetermainGeo />,
    label: "تعیین مناطق توزیع  / جمع آوری",
    permissions: "view_zone operation",
  },

  {
    code: "100105",
    to: "/planing",
    component: <Planing />,
    label: "برنامه ریزی",
    permissions: "view_planning",
  },
  {
    code: "",
    to: "/unplaned-consignments",
    component: <UnPlanedConsignemnt />,
    label: "تخصیص مرسوله",
    permissions: "view_assign_consignment_to_plan",
  },
  {
    code: "",
    to: "/settlement-credit",
    component: <CreditSettlement />,
    label: "تسویه اعتبار هاب",
    permissions: "paycredit",
  },
  {
    code: "",
    to: "/credit-allocate",
    component: <CreditAllocate />,
    label: "تخصیص اعتبار",
    permissions: "credit",
  },
  {
    code: "",
    to: "/accept-fish",
    component: <FishManagement />,
    label: "تایید فیش",
    permissions: "bank_receipt_confirm",
  },
   {
    code: "",
    to: "/sharePercent",
    component: <SharePercent />,
    label: "حق السهم",
    permissions: "share_percentage_management",
  },
     {
    code: "",
    to: "/desorganizationMangement",
    component: <DesorganizationMangement />,
    label: "درخواست بی ترتیبی",
    permissions: "view_anomaly_management",
  },

];
